import './ModuleDetailsDescription.scss';
import Subtitle from 'components/TextComps/Subtitle';
import Paragraph from 'components/TextComps/Paragraph';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@mui/material';

type ModuleDetailsDescriptionProps = {
  description: string | undefined;
  isPending: boolean;
};

export const ModuleDetailsDescription = ({ description, isPending }: ModuleDetailsDescriptionProps) => {
  const { t } = useTranslation();
  return (
    <section className='description'>
      {!isPending ? (
        <Subtitle>
          <>{t('ModuleDescription', { ns: 'learningHub' })}</>
        </Subtitle>
      ) : (
        <Skeleton width={150} height={30} style={{ marginBottom: 20 }} />
      )}
      {!isPending ? (
        <Paragraph className='content'>
          <>{description}</>
        </Paragraph>
      ) : (
        <>
          <Skeleton width={450} height={30} />
          <Skeleton width={400} height={30} />
          <Skeleton width={450} height={30} />
        </>
      )}
    </section>
  );
};
